import { render, staticRenderFns } from "./fccLocalDeProva.vue?vue&type=template&id=348a605b"
import script from "./fccLocalDeProva.vue?vue&type=script&lang=js"
export * from "./fccLocalDeProva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports